/**
 * Central ads config. Set your AdSense publisher id (client) and slot ids
 * here. Leaving any value empty DISABLES that ad slot entirely — the app
 * renders as if the ad doesn't exist (no placeholder, no empty reservation).
 *
 * AdSense dashboard → Ads → By ad unit → Create → copy `data-ad-client`
 * and `data-ad-slot` into the values below.
 */
export const AD_CLIENT = ""; // e.g. "ca-pub-1234567890123456"

export const AD_SLOTS = {
  header: "",        // 320x50 responsive display unit
  infeed: "",        // 300x250 in-feed or display unit
  stickyBottom: "",  // 320x50 sticky / anchor unit
};

// Only required if the in-feed unit was created as an "In-feed" ad type.
// (For plain Display units, leave empty and `format` will be "auto".)
export const AD_INFEED_LAYOUT_KEY = "";

export const hasAd = (key) => Boolean(AD_CLIENT && AD_SLOTS[key]);
export const ADS_ENABLED = Boolean(AD_CLIENT);
